import axios from '@/jslib/axios'

export const getReferralInfo = params => {
  return axios({
    method: 'get',
    url: '/admin/account/referral/info',
    params
  })
}
export const getReferralInvoices = params => {
  return axios({
    method: 'get',
    url: '/admin/account/referral/invoices',
    params
  })
}
export const referralCancel = params => {
  return axios({
    method: 'get',
    url: '/admin/account/referral/cancel',
    params
  })
}
export const sendMess = data => {
  return axios({
    method: 'post',
    url: '/admin/account/referral/send/mess',
    data
  })
}

export const getCurrencys = params => {
  return axios({
    method: 'get',
    url: '/admin/commission/binance/currencys',
    params
  })
}

export const getCurrencysPrice = params => {
  return axios({
    method: 'get',
    url: '/admin/commission/binance/currency/price',
    params
  })
}

export const binanceTransfer = data => {
  return axios({
    method: 'post',
    url: '/admin/commission/binance/transfer',
    data
  })
}

export const referralSettingDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/account/referral/setting/detail',
    params
  })
}

export const referralCouponSave = data => {
  return axios({
    method: 'post',
    url: '/admin/account/referral/coupon/save',
    data
  })
}

export const referralDiscountSave = data => {
  return axios({
    method: 'post',
    url: '/admin/account/referral/discount/save',
    data
  })
}
export const editCredit = data => {
  return axios({
    method: 'post',
    url: '/admin/edit/credit',
    data
  })
}
export const vipSubscribe = data => {
  return axios({
    method: 'post',
    url: '/admin/account/referral/subscribe',
    data
  })
}
export const customerMaxList = params => {
  return axios({
    method: 'get',
    url: '/admin/account/referral/max_reward/list',
    params
  })
}
export const setCustomerMaxList = data => {
  return axios({
    method: 'post',
    url: '/admin/account/referral/max_reward/set',
    data
  })
}
export const chargeReferrerStatus = data => {
  return axios({
    method: 'post',
    url: '/admin/account/referral/non/charge',
    data
  })
}
export const applyAccountReferrer = params => {
  return axios({
    method: 'get',
    url: '/admin/account/referral/apply',
    params
  })
}
export const showReferrerReward = data => {
  return axios({
    method: 'post',
    url: '/admin/referrer/reward/show',
    data
  })
}
